<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view/>
  </div>
</template>

<script>
// import Header from './components/Header'

export default {
  name:"app",
  components:{
    // Header
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  /* text-align: center;  */
  color: #2c3e50;
}

#nav {
  padding: 0px;
}

#nav a {
  font-weight: bold;
  
  color: rgba(255, 255, 255, 0.596);
}

#nav a:Hover{
  color:#fff

}
#nav a.router-link-exact-active {
  color: rgba(255, 255, 255, 0.295);
}


</style>
